import { render } from "./금연약물치료.vue?vue&type=template&id=660115c2"
import script from "./금연약물치료.vue?vue&type=script&lang=js"
export * from "./금연약물치료.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__